module.exports = __webpack_public_path__ + "media/images/stamps/vedett_allatok-5d5e103b93b785c147c0b18021e33a38.jpg";